import { render, staticRenderFns } from "./AboutSOS.vue?vue&type=template&id=5604ca2f&scoped=true&"
import script from "./AboutSOS.vue?vue&type=script&lang=js&"
export * from "./AboutSOS.vue?vue&type=script&lang=js&"
import style0 from "./AboutSOS.vue?vue&type=style&index=0&id=5604ca2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604ca2f",
  null
  
)

export default component.exports